// src/views/Contacto.jsx
import React from 'react';
import { Container, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import LabelConIcono from '../components/elementosuniv/LabelConIcono';

// Importamos íconos desde react-icons (Font Awesome)
import { 
  FaPhone, 
  FaEnvelope, 
  FaWhatsapp, 
  FaCalendarAlt, 
  FaClock, 
  FaMapMarkerAlt, 
  FaGlobe 
} from 'react-icons/fa';

const Contacto = () => {
  const navigate = useNavigate();

  // Datos a mostrar
  const items = [
    {
      icon: <FaPhone size={24} color="#bb1194" />,
      text: '+593 979348697',
      onClick: () => window.open('tel:+593979348697')
    },
    {
      icon: <FaEnvelope size={24} color="#bb1194" />,
      text: 'info@sgconsulting.site',
      onClick: () => window.open('mailto:info@sgconsulting.site')
    },
    {
      icon: <FaWhatsapp size={24} color="#bb1194" />,
      text: '+593 979348697',
      onClick: () => window.open('https://wa.me/593979348697')
    },
    {
      icon: <FaCalendarAlt size={24} color="#bb1194" />,
      text: 'Lunes a viernes'
    },
    {
      icon: <FaClock size={24} color="#bb1194" />,
      text: '09:00 a 18:00'
    },
    {
      icon: <FaMapMarkerAlt size={24} color="#bb1194" />,
      text: 'Ubicación',
      onClick: () =>
        window.open('https://www.google.com/maps/search/?api=1&query=SG+Consulting')
    },
    {
      icon: <FaGlobe size={24} color="#bb1194" />,
      text: 'www.sgconsulting.site',
      onClick: () => window.open('https://www.sgconsulting.site', '_blank')
    }
  ];

  return (
    <Container className="py-5">
      {items.map(({ icon, text, onClick }, i) => (
        <LabelConIcono
          key={i}
          IconoLabel={icon}
          TextoLabel={text}
          JerarqLabel="secundario"
          esClickable={!!onClick}
          onClick={onClick}
          labelStyle={{
            display: 'flex',
            alignItems: 'center',
            cursor: onClick ? 'pointer' : 'default',
            marginBottom: '1rem'
          }}
          textStyle={{ fontSize: '1rem', marginLeft: '0.5rem' }}
        />
      ))}

      <div className="text-center mt-4">
        <Button
          color="primary"
          size="lg"
          onClick={() => navigate('/app/agenda-llamada')}
        >
          AGENDAR LLAMADA
        </Button>
      </div>
    </Container>
  );
};

export default Contacto;
